import { useState, useEffect } from "react";
import "./Register.css";
import { register } from "../services/authService";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMatches } from "../redux/matchFilterSlice";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
export default function Register({ onSwitchToLogin }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { list } = useSelector((state) => state.matches);
    const { t, i18n } = useTranslation();

  const [form, setForm] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirm: "",
    lookingFor: "",
    profession: "",
    professionDetails: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
   const [profession, setProfession] = useState([]);

   useEffect(() => {
      dispatch(fetchMatches());     
    }, [dispatch]);

    useEffect(() => {
      console.log("MATCHES IN REGISTER:", list);
      if (list?.data) {
      const types = list.data;


     

      //get occupation list
      const professions = types
        .filter((f) => f.isActive && f.masterType === "Occupation")
        .map((p) => p);
      setProfession(professions);
      console.log("profession:", professions);
    }
    }, [list]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
    const { name, value } = e.target;
    if (name === "phone") {
      const numericOnly = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, phone: numericOnly }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (
      !form.firstName ||
      !form.email ||
      !form.password ||
      !form.confirm ||
      !form.phone ||
      !form.profession      
    )
      return setError(t("all_fields_required"));

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      return setError(t("valid_email"));
    if (!/^\d{10}$/.test(form.phone))
      return setError(t("valid_phone"));

    if (form.password.length < 6)
      return setError(t("password_length"));

    if (form.password !== form.confirm)
      return setError(t("password_match"));

    setLoading(true);

    try {
      const username = form.username || form.firstName.toLowerCase();
      
      const res = await register(
        username,
        form.email,
        form.password,
        form.phone,
        form.profession,
        form.professionDetails,
      );
      console.log(t("register_success"), res);
      setSuccess(t("account_created_successfully"));
      setForm({
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirm: "",
        lookingFor: "",
        profession: "",
        professionDetails: "",
      });
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      console.error(t("register_error"), err.response?.data || err.message);
      setError(
        err.response?.data?.error ||
          err.response?.data?.message ||
          t("registration_failed"),
      );
    }

    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="reg-page" data-lang={i18n.language}>
      {/* ── Main Layout ── */}
      <div className="reg-main">
        <div className="reg-left">
          <div className="reg-left-content">
            <h1 className="reg-hero-title">{t("where_hearts_find_home")}</h1>
            <p className="reg-hero-sub">
              {t("begin_journey")}
            </p>
          </div>
          {/* Wave/Curve SVG cutout on right edge */}
          <div className="reg-left-wave"></div>
        </div>

        {/* Right: Form card */}
        <div className="reg-right">
          <div className="reg-card">
            {/* Tabs */}
            <div className="reg-tabs">
              <button className="rt-tab" onClick={() => navigate("/login")}>
                {t("login")}
              </button>
              <button className="rt-tab active">{t("sign_up")}</button>
            </div>

            <div className="reg-card-top">
              <h2>{t("find_your_match")}</h2>
              <p>{t("create_profile")}</p>
            </div>

            {error && <div className="reg-alert reg-err">{error}</div>}
            {success && (
              <div className="reg-alert reg-ok">
                <span>✓</span>
                {success}
              </div>
            )}

            <div className="reg-form">
              {/* Looking For */}
              <div className="reg-row">
                {/* Looking For */}
                <div className="reg-field">
                  <label>{t("looking_for")}</label>
                  <div className="rf-box rf-select">
                    <select
                      name="lookingFor"
                      value={form.lookingFor}
                      onChange={handleChange}
                    >
                      <option value="">{t("select_one")}</option>
                      <option value="bride">{t("bride")}</option>
                      <option value="groom">{t("groom")}</option>
                    </select>

                    <span className="rf-chevron">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </div>
                </div>

                {/* Job Title */}
                {/* i need if job title is others then show input field otherwise show dropdown */}
                <div className="reg-field">
                  <label>{t("profession_label")}</label>

                  <div className="rf-box rf-select">
                      <select
                        name="profession"
                        value={form.profession}
                        onChange={handleChange}
                      >
                        <option value="">{t("select_profession")}</option>
                        {profession.map((p) => (
                          <option key={p._id} value={p.masterValue?.["en"]}>
                            {p.masterValue?.[i18n.language] || p.masterValue?.["en"]}
                          </option>
                        ))}
                        {/* <option value="software_engineer">
                          Software Engineer
                        </option>
                        <option value="doctor">Doctor</option>
                        <option value="teacher">Teacher</option>
                        <option value="business">Business</option>
                        <option value="others">Others</option> */}
                      </select>

                      <span className="rf-chevron">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                        >
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </span>
                    </div>

                  {/* {form.profession === "Others" && (
                    <div className="rf-box">
                      <input
                        type="text"
                        name="professionDetails"
                        value={form.professionDetails}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Profession"
                      />
                    </div>
                  )} */}
                    
                  
                </div>
              </div>

              {/* //show profession other input field if user selects others from dropdown */}
               {form.profession === "Others" && (
              <div className="reg-row">
                {/* Looking For */}
                <div className="reg-field">
                  <label>{t("custom_profession")}</label>
                    <div className="rf-box1">
                      <input
                        type="text"
                        name="professionDetails"
                        value={form.professionDetails}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder={t("enter_profession")}
                      />
                    </div>
                </div>
                </div>
                 )}

              {/* First + Last Name */}
              <div className="reg-row">
                <div className="reg-field">
                  <label>{t("first_name")}</label>
                  <div className="rf-box">
                    <input
                      name="firstName"
                      value={form.firstName}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Sanjau"
                    />
                  </div>
                </div>
                <div className="reg-field">
                  <label>{t("last_name")}</label>
                  <div className="rf-box">
                    <input
                      name="lastName"
                      value={form.lastName}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Samson"
                    />
                  </div>
                </div>
              </div>

              {/* Email + Phone */}
              <div className="reg-row">
                <div className="reg-field">
                  <label>{t("email_address")}</label>
                  <div className="rf-box">
                    <input
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Sanju@gmail.com"
                    />
                  </div>
                </div>
                <div className="reg-field">
                  <label>{t("phone_number")}</label>
                  <div className="rf-box">
                    <input
                      name="phone"
                      type="tel"
                      value={form.phone}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="(+91)"
                      pattern="[0-9]*"
                      maxLength={10}
                      inputMode="numeric"
                    />
                  </div>
                </div>
              </div>

              {/* Password + Confirm */}
              <div className="reg-row">
                <div className="reg-field">
                  <label>{t("password")}</label>
                  <div className="rf-box rf-pass">
                    <span className="rf-lock">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <rect
                          x="3"
                          y="11"
                          width="18"
                          height="11"
                          rx="2"
                          ry="2"
                        />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      name="password"
                      type={showPass ? "text" : "password"}
                      value={form.password}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="••••••••"
                    />
                    <button
                      className="rf-eye"
                      onClick={() => setShowPass(!showPass)}
                      type="button"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="reg-field">
                  <label>{t("confirm_password")}</label>
                  <div className="rf-box rf-pass">
                    <span className="rf-lock">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <rect
                          x="3"
                          y="11"
                          width="18"
                          height="11"
                          rx="2"
                          ry="2"
                        />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      name="confirm"
                      type={showConfirm ? "text" : "password"}
                      value={form.confirm}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      placeholder="••••••••"
                    />
                    <button
                      className="rf-eye"
                      onClick={() => setShowConfirm(!showConfirm)}
                      type="button"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </button>
                  </div>
                  {form.confirm && (
                    <span
                      className={`match-msg ${form.password === form.confirm ? "ok" : "no"}`}
                    >
                      {form.password === form.confirm
                        ? t("passwords_match")
                        : t("passwords_dont_match")}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Sign Up Button */}
            <button
              className="reg-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? <span className="reg-spin"></span> : t("sign_up")}
            </button>

            {/* OR divider */}
            {/* <div className="reg-or">
              <span>OR</span>
            </div> */}

            {/* Google */}
            {/* <button className="reg-google-btn" type="button">
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Continue with Google
            </button> */}

            <p className="reg-switch">
              {t("already_have_profile")}{" "}
              <button className="rs-link" onClick={() => navigate("/login")}>
                {t("login")}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
